import { render } from "./Divider.vue?vue&type=template&id=d1b8eefa&scoped=true&ts=true"
import script from "./Divider.vue?vue&type=script&lang=ts"
export * from "./Divider.vue?vue&type=script&lang=ts"

import "./Divider.vue?vue&type=style&index=0&id=d1b8eefa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b8eefa"]])

export default __exports__